module.exports = __webpack_public_path__ + "img/baidu.8a577b0a.png";